<template>
  <svg aria-hidden="true" viewBox="0 0 1200 1200" ...attributes>
    <path
      fill="#1B2D3C"
      d="M660 400v40h300v71.9l-360 240-360-240v-71.9h300v-40h-340v600h800v-600h-340zm300 160v280l-210-140 210-140zm-510 140l-210 140v-280l210 140zm-210 260v-71.9l246.1-164 113.9 75.9 113.9-76 246.1 164v72h-720z"
    ></path>
    <path
      fill="#63CC98"
      d="M620 568.6v-448.6c0-11-9-20-20-20s-20 9-20 20v448.6l-102-68v48.1l122 81.3 122-81.3v-48.1l-102 68z"
    ></path>
  </svg>
</template>
